"use strict";
/**
 * imports
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TickHandler = void 0;
// external
const React = require("react");
const moment = require("moment");
// local
const currentUnixTimestamp_1 = require("../../../../apis/spg/util/currentUnixTimestamp");
const TickContext_1 = require("../../../../contexts/TickContext");
/**
 * tick handler component
 */
class TickHandler extends React.Component {
    /**
     * constructor
     *
     * @param {ITickHandlerProps} props
     */
    constructor(props) {
        super(props);
        // current tick
        this.nextTick = null;
        // set the initial tick to the timestamp now
        this.state = {
            tick: (0, currentUnixTimestamp_1.currentUnixTimestamp)()
        };
    }
    /**
     * trigger the next tick and setup for the one after
     *
     * @private
     */
    _triggerTick() {
        //get props
        const { tickDuration = 60 } = this.props;
        // validate value of tickDuration
        if (!(tickDuration > 0 && tickDuration <= 60)) {
            throw new Error("tick duration must be great than 0 and less than or equal to 60 seconds");
        }
        // get timestamp now
        const now = (0, currentUnixTimestamp_1.currentUnixTimestamp)();
        // get the current exact minute we are one
        const currentMinute = moment()
            .seconds(0)
            .unix();
        // calculate the seconds until the next minute from now
        const secondsUntilNextMinute = 60 - (now - currentMinute);
        // get timestamp when next tick is due
        const due = now + tickDuration;
        // get seconds until the next tick
        let secondsUntilNexTick = due - now;
        if (secondsUntilNexTick > secondsUntilNextMinute) {
            secondsUntilNexTick = secondsUntilNextMinute;
        }
        // re-render
        this.setState({
            tick: now
        });
        // setup timeout to calculate the next tick based
        this.nextTick = setTimeout(() => {
            // calculate the tick after
            this._triggerTick();
        }, secondsUntilNexTick * 1000);
    }
    /**
     * component did mount
     */
    componentDidMount() {
        // start the tick trigger
        this._triggerTick();
    }
    /**
     * remove tick counter
     */
    componentWillUnmount() {
        // cleanup and remove timeout
        clearTimeout(this.nextTick);
        this.nextTick = null;
    }
    /**
     * render
     *
     * @returns {any}
     */
    render() {
        // get the current tick and add it to the provider
        const { tick } = this.state;
        const provider = {
            tick
        };
        // pass in children to wrap context later
        const { children } = this.props;
        return (React.createElement(TickContext_1.TickContext.Provider, { value: provider }, children));
    }
}
exports.TickHandler = TickHandler;
//# sourceMappingURL=index.js.map